import i18n from '../../i18n';

export class Text {
  static get title(): string {
    return i18n._translate('Challenges', {
      context: 'A heading above a row of cards telling the user that these are challenges.',
    });
  }

  static get viewChallenge(): string {
    return i18n._translate('View challenge', {
      context: 'A call to action indicating there is more information about a challenge.',
    });
  }
}
